import { gql } from '@apollo/client'

import { ProductWithOfferFragmentDoc } from '@shared/generated'

/*
  searchProducts with a scope (filter / category_id).

  The codegen'd SearchProducts document declares only shopId/searchQuery/pager,
  so it cannot narrow a search. A landing's custom header does need that — it
  searches inside the landing's own assortment — and this document adds the two
  arguments the schema already accepts. Declared here rather than in the .graphql
  file so regenerating types is not required to ship it.
*/
export const GQL_SCOPED_SEARCH_PRODUCTS = gql`
  query ScopedSearchProducts(
    $shopId: ID!
    $searchQuery: SearchQuery!
    $style: String
    $pager: CommonPagerInput
    $filter: NestedFilterInput
    $categoryId: ID
  ) {
    searchProducts(
      shop_id: $shopId
      searchQuery: $searchQuery
      pager: $pager
      filter: $filter
      category_id: $categoryId
    ) {
      edges {
        ...ProductWithOffer
      }
    }
  }
  ${ProductWithOfferFragmentDoc}
`
